import push from "./push";

/**
 * Sends a `addToCart` event for Google Tag Manager
 * https://developers.google.com/tag-manager/devguide#multipush
 */
export default function pushAddToCart(sessionId: string | null): Promise<void> {
    return push("addToCart", {
        "session-id": sessionId //This unique id will be used to dedupe Facebook pixel/s2s records
    });
}
